import React, { useState } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import { IconContext } from "react-icons";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Form from "react-bootstrap/Form";

import "./Navbar.css";
import "font-awesome/css/font-awesome.min.css";

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => {
    setSidebar(!sidebar);
  };

  return (
    <div>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar navbar-fixed-top">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
          <div className="icon-text d-none d-md-block">
            <span>
              <FaIcons.FaRegBookmark className="icon" /> Base de Conhecimento Gigabyte Telecom
            </span>
          </div>

          <div className="menu-bars-right">
            <Form inline="true">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="button-tooltip-2">Site Gigabyte</Tooltip>}
              >
                <Button
                  variant="outline-warning"
                  className="mr-sm-2 custom-margin-button"
                  href="https://gigabytetelecom.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-fw fa-wpforms" style={{ fontSize: "1.25em" }}></i>
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="button-tooltip-2">MK Solutions</Tooltip>}
              >
                <Button
                  variant="outline-primary"
                  className="mr-sm-2 custom-margin-button"
                  href="https://mk.gigabytetelecom.com.br/mk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-fw fa-tasks" style={{ fontSize: "1.25em" }}></i>
                </Button>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={<Tooltip id="button-tooltip-2">Sistem de Ordem de Serviço(OS)</Tooltip>}>
                <Button
                  variant="outline-success"
                  className="mr-sm-2 custom-margin-button"
                  href="https://atendimento.gigabytetelecom.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-fw fa-cogs" style={{ fontSize: "1.25em" }}></i>
                </Button>
              </OverlayTrigger>
            </Form>
          </div>
        </div>
        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars">
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <div className="menu-sidebar">
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </li>
                </div>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </div>
  );
};

export default Navbar;
